import { createApp } from "vue";
import vui from "vui";
import App from "App";

const el = document.getElementById("termly");

if (el) {
	const app = createApp(App, { src: el.dataset.url });

	app.use(vui);
	app.mount(el);
}
